<div
  (chartInit)="myChart = $event" [initOpts]="{width: 150,height: 150}"
  [options]="option"
  class="chart" echarts>
</div>